module.exports = __webpack_public_path__ + "img/as1.bc8895bd.png";